import React from 'react'
import { FullWidthWrapper } from '../shared/layouts'
import TwitterIcon from '../../assets/icons/twitter-icon.png'
import OSIcon from '../../assets/icons/os-icon.png'
import OSSkoolverseIcon from '../../assets/icons/os-skoolverse-icon.png'
import ScholarzIcon from '../../assets/icons/scholarz-icon.png'
import Wrapper from './style'
import { SchLinkItem } from '../shared/atoms'

const Footer = ({className}) => {
	return (
		<Wrapper className={className}>
			<FullWidthWrapper
				className='inner-wrapper'
			>
				<div className="copyright">
				© {new Date().getFullYear()} Scholarz.
				</div>
				<div className="links-list">
					<SchLinkItem
						href="//www.scholarz.io"
						target='_blank'
						rel='noreferrer'
						aria-label='Scholarz'
					>
						<img src={ScholarzIcon} alt='scholarz' />
					</SchLinkItem>
					<SchLinkItem
						href="//dashboard.scholarz.io"
						target='_blank'
						rel='noreferrer'
						aria-label='Scholarz-dashboard'
					>
						<img src={ScholarzIcon} alt='dashboard-scholarz' />
					</SchLinkItem>
					<SchLinkItem
						href="//www.twitter.com/scholarznft"
						target='_blank'
						rel='noreferrer'
						aria-label='OpenSea'
					>
						<img src={TwitterIcon} alt='twit-scholarz' />
					</SchLinkItem>
					<SchLinkItem
						href="//opensea.io/collection/scholarz"
						target='_blank'
						rel='noreferrer'
						aria-label='OpenSea'
					>
						<img src={OSIcon} alt='open-sea' />
					</SchLinkItem>
					<SchLinkItem
						href="//opensea.io/collection/skoolverse"
						target='_blank'
						rel='noreferrer'
						aria-label='OpenSea'
					>
						<img src={OSSkoolverseIcon} alt='open-sea' />
					</SchLinkItem>
				</div>
			</FullWidthWrapper>
		</Wrapper>
	)
}

export default Footer